'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { createContext } from 'react';

import PropTypes from 'prop-types';

export const BlockContext = createContext();

const BlockProvider = ({ children, id }) => {
    return <BlockContext.Provider value={id}>{children}</BlockContext.Provider>;
};

BlockProvider.propTypes = {
    children: PropTypes.object.isRequired,
    id: PropTypes.string,
};

export default BlockProvider;
